import { ResumeStats } from '../models/ResumeStats.js';
import { PRDetector } from './PRDetector.js';
import { summarizeRaces } from '../../../../functions/shared/raceMetrics.mjs';

export class StatsCalculator {
  static calculate(races = []) {
    races = races || [];
    return new ResumeStats({
      ...summarizeRaces(races),
      highlightedCount: races.filter(r => r.isHighlighted).length,
      prByDistance: PRDetector.detect(races),
    });
  }
}
